import { EMPTY_LIST, EMPTY_OBJECT } from '../../../../constants/common'
import { FORMIK_EMPTY_VALUE } from '../../../../constants/validation'
import { getItemsIds } from '../../../../utils/common'
import { EMAIL_CREATION_FORM_RECIPIENT_FIELD_EXPAND_API_PARAM } from '../../EmailCreationForm'

import {
  EMAIL_RECIPIENTS_BUILDING_FIELD_NAME,
  EMAIL_RECIPIENTS_FLAT_FIELD_NAME,
  EMAIL_RECIPIENTS_GROUP_FIELD_NAME,
  EMAIL_RECIPIENTS_ROLE_FIELD_NAME,
  EMAIL_RECIPIENTS_USER_INFO_STATUS_FIELD_NAME,
  EMAIL_RECIPIENTS_WITH_PROPERTY_OWNERS_FIELD_NAME,
  GROUP_OPTIONS,
} from './EmailRecipientsFilterModal.constants'

export function getOptions(options, t) {
  return options.map(item => {
    return {
      ...item,
      label: t(item.label),
    }
  })
}

export function getRecipientFilterParams(values, options = EMPTY_OBJECT) {
  const filters = { archived: false }

  if (values[EMAIL_RECIPIENTS_ROLE_FIELD_NAME]) {
    filters.role = [values[EMAIL_RECIPIENTS_ROLE_FIELD_NAME].value]
  }

  if (values[EMAIL_RECIPIENTS_FLAT_FIELD_NAME].length > 0) {
    filters.flat = getItemsIds(
      values[EMAIL_RECIPIENTS_FLAT_FIELD_NAME],
      'value'
    )
  } else if (values[EMAIL_RECIPIENTS_BUILDING_FIELD_NAME].length > 0) {
    filters.building = getItemsIds(
      values[EMAIL_RECIPIENTS_BUILDING_FIELD_NAME],
      'value'
    )
  }

  if (values[EMAIL_RECIPIENTS_USER_INFO_STATUS_FIELD_NAME]) {
    filters.personal_status = getItemsIds(
      values[EMAIL_RECIPIENTS_USER_INFO_STATUS_FIELD_NAME],
      'value'
    )
  }

  if (values[EMAIL_RECIPIENTS_WITH_PROPERTY_OWNERS_FIELD_NAME]) {
    filters.with_property_owners = true
  }

  return {
    ...(options.autoAddEnabled
      ? EMAIL_CREATION_FORM_RECIPIENT_FIELD_EXPAND_API_PARAM
      : null),
    filters,
  }
}

export function isEqualEmailRecipientsFilterModal({ values }) {
  return (
    values[EMAIL_RECIPIENTS_BUILDING_FIELD_NAME].length === 0 &&
    values[EMAIL_RECIPIENTS_USER_INFO_STATUS_FIELD_NAME].length === 0 &&
    !values[EMAIL_RECIPIENTS_ROLE_FIELD_NAME] &&
    !values[EMAIL_RECIPIENTS_WITH_PROPERTY_OWNERS_FIELD_NAME]
  )
}

export function getInitialValues(initialValues, t) {
  return {
    [EMAIL_RECIPIENTS_BUILDING_FIELD_NAME]: EMPTY_LIST,
    [EMAIL_RECIPIENTS_FLAT_FIELD_NAME]: EMPTY_LIST,
    [EMAIL_RECIPIENTS_GROUP_FIELD_NAME]: getOptions(GROUP_OPTIONS, t)[0],
    [EMAIL_RECIPIENTS_ROLE_FIELD_NAME]: FORMIK_EMPTY_VALUE,
    [EMAIL_RECIPIENTS_USER_INFO_STATUS_FIELD_NAME]: EMPTY_LIST,
    [EMAIL_RECIPIENTS_WITH_PROPERTY_OWNERS_FIELD_NAME]: false,
    ...initialValues,
  }
}
